<template>
    <div class="col-11 col-md-7 col-lg-7 snackbar"
         v-if="propObj.isOpen"
         :class="[type ? 'snackbar--'+type : '']">

        <div class="snackbar__icon" v-if="type === 'error'">
            <svg viewBox="0 0 24 24">
                <use xlink:href="#attention"></use>
            </svg>
        </div>
        <div class="snackbar__icon" v-if="type === 'success'">
            <svg viewBox="0 0 24 24">
                <use xlink:href="#validation"></use>
            </svg>
        </div>
        <div class="snackbar__content">
            <slot></slot>
        </div>
        <button type="button" class="snackbar__close" @click="closeSnackbar">
            <svg viewBox="0 0 65 65">
                <use xlink:href="#close"></use>
            </svg>
        </button>
    </div>
</template>

<script>

    export default {
        props: {
            type: {
                default: 'error',
                required: false
            },
        },
        data() {
            return {
                propObj: {
                    isOpen: true,
                    autoDestroy: 3
                }
            }
        },
        methods: {
            closeSnackbar() {
                this.propObj.isOpen = false
            }
        },
        mounted() {
            if (this.propObj.autoDestroy > 0) {
                let timeout = window.setInterval(() => {
                    this.propObj.isOpen = false
                    this.$emit('closed', true)
                    window.clearInterval(timeout);
                }, this.propObj.autoDestroy * 1000);
            }

        }
    }
</script>
